(function () {

    'use strict';
    angular.module('angulartics.hurra', [
        'angulartics'
    ])
    .config(config);

    config.$inject = [
        '$analyticsProvider',
        '$windowProvider'
    ];

    function config($analyticsProvider, $windowProvider) {
        var $window = $windowProvider.$get(),
            angulartics = $window.angulartics;
        $analyticsProvider.settings.hurra = {
            trackingEnabled: false
        };
        $analyticsProvider.registerSetUserProperties(function (properties) {
            properties = properties || {};

            angular.forEach(properties.hurra, function (value, prop) {
                $analyticsProvider.settings.hurra[prop] = value;
            });
        });

        angulartics.waitForVendorApi('hc_tm', 500, function (hc_tm) {
            $analyticsProvider.registerEventTrack(function (action, properties) {
                var params = {},
                    trackingProvider;

                properties = properties || {};

                trackingProvider = angular.isArray(properties.trackingProvider) ? properties.trackingProvider : [properties.trackingProvider];

                if (hc_tm && action && trackingProvider.indexOf('hurra') > -1 && $analyticsProvider.settings.hurra.trackingEnabled) {
                    try {
                        delete properties.trackingProvider;

                        params = angular.merge({
                            page_type: action,
                            orderId: $analyticsProvider.settings.hurra.orderId
                        }, properties);

                        hc_tm.push({
                            e: 'track',
                            p: params
                        });

                    } catch (error) {
                    }
                }

            });
        });
    }
})();
